import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table,
} from 'antd';
import dayjs from 'dayjs';
import { toISTDate } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import PurchaseRequestActions from '@Actions/purchaseRequestActions';
import UserActions from '@Actions/userActions';
import H3Modal from '@Uilib/H3Modal';
import ViewInvoice from '@Components/Sales/Invoice/ViewInvoice';
import './style.scss';
import HideValue from '../../../Common/RestrictedAccess/HideValue';
/**
 * @param status
 */
class InvoicesList extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    const { priceMasking } = props;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
    this.state = {
      currentPage: 1,
      limit: 10,
      startDate: dayjs().valueOf(),
      openSelectedDuration: dayjs().subtract(300, 'd').valueOf(),
      closedSelectedDuration: 'LAST 60 DAYS',
      openPurchaseOrderModal: false,
      openGRNModal: false,
      openGRNModalView: false,
      openUpdatePurchaseOrderModal: false,
      expandedRowKeys: [],
      tableColumns: [
        {
          title: '',
          render: (record) => (
            <div onClick={() => {
              this.setState({ selectedInvoice: record, showInvModal: true });
            }}
            >
              <div className="mobile-list__item">
                <div style={{ display: 'flex' }}>
                  <H3Text text={`#${record?.invoice_number}`} className="mobile-list__item-number" />
                </div>
                <div className="mobile-list__item-info">
                  {`Business Unit - ${record.tenant_info?.tenant_name}`}
                </div>
                <div className="mobile-list__item-info">
                  {`SO # - ${record?.sales_order_number || ''}`}
                </div>
                <div className="mobile-list__item-info">
                  {`Customer - ${record?.customer_info?.customer_name}`}
                </div>
                <div className="mobile-list__item-info">
                  {`Items - ${record.no_of_items}`}
                </div>
                <H3Text text={`Due Date - ${toISTDate(record?.invoice_date).format('DD/MM/YYYY')}`} className="mobile-list__item-info" />
                <H3Text text={`Invoice Amount - ${this.props.MONEY(record?.invoice_grand_total)}`} className="mobile-list__item-info" />
                <H3Text text={`Requested by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-footer" />
              </div>
            </div>
          ),
          responsive: ['xs'],
        },
        {
          title: 'INVOICE #',
          render: (record) => (
            <div className="column-number__wrapper">
              {record?.invoice_number}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'BUSINESS UNIT',
          render: (text, record) => (
            <div className="associated-entity">
              {record.tenant_info?.tenant_name}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'SO #',
          render: (text, record) => {
            const { user } = this.props;
            return (
              <div>
                {record?.sales_order_number}
              </div>
            );
          },
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'CUSTOMER',
          render: (text, record) => (
            <div>
              {record?.customer_info?.customer_name}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'ITEMS',
          render: (item) => (
            <div>
              {item?.no_of_items}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'DATE',
          render: (record) => (
            <div>
              <div className="column-date">
                {toISTDate(record?.invoice_date).format('DD/MM/YYYY')}
              </div>
              <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'INVOICE AMOUNT',
          render: (item, record) => (
            <div className="column-amount">
              {(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view invoice amount"} /> : this.props.MONEY((record?.document_invoice_grand_total || record?.invoice_grand_total || '0'), record?.org_currency_info?.currency_code)}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'DUE DATE',
          render: (record) => (
            <Fragment>
              <div className="column-date">
                {record?.invoice_due_date ? toISTDate(record?.invoice_due_date).format('DD/MM/YYYY') : '-'}
                {' '}
              </div>
            </Fragment>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: '',
          key: 'action',
          fixed: 'right',
          render: (record) => (
            <div className="list__actions">
              <div
                className="list__actions-button list__actions-button-dark"
                onClick={() => {
                  this.setState({ selectedInvoice: record, showInvModal: true });
                }}
              >
                View
              </div>
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          className: 'list__actions-column',
        },
      ],
    };
  }

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    if (props.user && !state.isUserReady) {
      const { getPendingActions } = props;
      getPendingActions('map_inv', 10, state.currentPage, () => { });
      return {
        ...state,
        isUserReady: true,
      };
    }
    return state;
  }

  /**
   *
   * @param {*} status
   * @return
   */
  render() {
    const {
      pendingActions, getPendingActionsLoading, getPendingActions,
    } = this.props;
    const {
      currentPage, tableColumns, showInvModal, selectedInvoice,
    } = this.state;
    return (
      <Fragment>
        <div className="doc-list__wrapper">
          <div className="ant-row">
            <div className="ant-col-md-24 ant-col-xs-24">
              <div className="doc-list__table-wrapper">
                <Table
                  title={() => (
                    <div className="doc-list__table-header">
                      <div className="doc-list__table-header__left">
                        {`${Number(pendingActions?.inv_approval_count)} Invoices`}
                      </div>
                    </div>
                  )}
                  loading={getPendingActionsLoading}
                  showHeader
                  size="small"
                  scroll="scroll"
                  columns={tableColumns}
                  rowKey="po_id"
                  dataSource={pendingActions?.invoices || []}
                  pagination={(Number(pendingActions?.inv_approval_count) > 10) ? {
                    defaultCurrent: 1,
                    current: currentPage,
                    total: Number(pendingActions?.inv_approval_count),
                    pageSize: 10,
                    onChange: (page) => {
                      getPendingActions('map_inv', 10, currentPage, () => { });
                      this.setState({ currentPage: page });
                    },
                    position: ['bottomRight'],
                    showSizeChanger: false,
                  } : false}
                />
              </div>
            </div>
          </div>
        </div>
        <H3Modal
          onClose={() => {
            getPendingActions('map_inv', 10, currentPage, () => { });
            this.setState({ showInvModal: false });
          }}
          className="pending-po__view-po"
          isOpen={showInvModal}
          title={`Invoice #${selectedInvoice ? selectedInvoice?.invoice_number : ''} for ${selectedInvoice?.tenant_info?.tenant_name}`}
          showHeader
        >
          <ViewInvoice isQuickView selectedInvId={selectedInvoice?.invoice_id} selectedTenantId={selectedInvoice?.tenant_info?.tenant_id} />
        </H3Modal>
      </Fragment>
    );
  }
}

/**
 *
 * @param UserReducers
 * @param PurchaseRequestReducers
 * @return {{purchaseRequests: *, getPurchaseRequestsLoading: *, user}}
 */
const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getPendingActionsLoading: UserReducers.getPendingActionsLoading,
  pendingActions: UserReducers.pendingActions,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getPendingActions: (actionType, limit, page, callback) => dispatch(UserActions.getPendingActions(actionType, limit, page, callback)),
  getPurchaseRequestsSuccess: (purchaseRequests) => dispatch(PurchaseRequestActions.getPurchaseRequestsSuccess(purchaseRequests)),
});

InvoicesList.propTypes = {
  user: PropTypes.any,
  history: PropTypes.func,
  getPendingActions: PropTypes.func,
  getPendingActionsLoading: PropTypes.bool,
  pendingActions: PropTypes.any,
  MONEY: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InvoicesList));
